<template>
  <div>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="majorName" label="姓名：">
                  <el-input size="small" v-model="form.majorName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="albumTitle" label="准考证号：">
                  <el-input size="small" v-model="form.albumTitle"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="classCode" label="手机号：">
                  <el-input size="small" v-model="form.classCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="majorName" label="支付状态：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.applyType"
                    placeholder="-不限-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in applyTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="albumTitle" label="审核状态：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.albumTitle"
                    placeholder="-不限-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="closeClassTime" label="导入时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.closeClassTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="applyType" label="开课批次：">
                  <el-input size="small" v-model="form.classCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="applyType" label="用户名：">
                  <el-input size="small" v-model="form.classCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button type="primary">导出筛选结果</el-button>
        <el-button type="primary" @click="importStudentsDialogVisible = true"
          >导入学员状态</el-button
        >
        <el-button type="primary">移除导入学员</el-button>
      </div>
      <el-dialog
        title="导入学员："
        :visible.sync="importStudentsDialogVisible"
        width="700px"
        destroy-on-close
      >
        <el-form
          ref="importStudentsForm"
          :rules="importStudentsFormRules"
          :model="importStudentsForm"
          label-width="auto"
        >
          <el-form-item prop="status" label="导入学员默认状态">
            <el-radio v-model="importStudentsForm.status" label="1">
              审核通过未缴费
            </el-radio>
            <el-radio v-model="importStudentsForm.status" label="2">
              审核退回未缴费
            </el-radio>
            <el-radio v-model="importStudentsForm.status" label="3">
              审核退回无需缴费
            </el-radio>
          </el-form-item>
        </el-form>
        <el-row type="flex" align="middle">
          <el-col :span="5">
            <el-button type="primary" style="width: 100%">下载模板</el-button>
          </el-col>
          <el-col :span="5">
            <el-upload
              class="upload-demo"
              action="#"
              :on-change="handleChange"
              :limit="1"
              :before-upload="beforeUpload"
              :file-list="fileList"
              style="width: 100%"
            >
              <el-button type="primary" style="width: 100%"
                >选择上传文件</el-button
              >
            </el-upload>
          </el-col>
          <el-col :span="6">
            <div class="upload__tip">只能导入excel文件</div>
          </el-col>
        </el-row>
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; justify-content: center"
        >
          <el-button type="primary" @click="importStudents">
            导入学员
          </el-button>
        </span>
      </el-dialog>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column
        prop="id"
        label="开课批次/班级编码"
        align="center"
      ></el-table-column>
      <el-table-column prop="albumTitle" label="用户名" align="center">
      </el-table-column>
      <el-table-column prop="albumTitle" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="albumTitle" label="学生所在专业" align="center">
      </el-table-column>
      <el-table-column
        prop="classCode"
        label="手机号（账号）"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="majorName"
        label="准考证号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="cover"
        label="导入时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="year"
        label="审核状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="term"
        label="支付状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="price"
        label="缴费时间"
        align="center"
      ></el-table-column>
      <el-table-column prop="uname" label="操作" min-width="70" align="center">
        <template>
          <div class="table_control">
            <span class="table_control_item">查看报名信息</span>
            <span class="table_control_item">移除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: [],
      form: {},
      applyTypeList: [
        { label: '未缴费', value: '1' },
        { label: '已缴费', value: '2' },
        { label: '无需缴费', value: '3' },
        { label: '已退款', value: '4' },
      ],
      statusList: [
        { label: '待审核', value: '1' },
        { label: '审核通过', value: '2' },
        { label: '审核退回', value: '3' },
        { label: '审核不通过', value: '4' },
        { label: '无需审核', value: '5' },
      ],
      importStudentsDialogVisible: false,
      importStudentsFormRules: {
        status: [{ required: true, message: '必选', trigger: 'blur' }],
        fileId: [{ required: true, message: '必选', trigger: 'blur' }],
      },
      importStudentsForm: {
        status: '1',
        fileId: '',
      },
      fileList: [],
      tableData: [{}],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
    }
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    search() {},
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
      }
    },
    delAll() {},
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    // 上传文件之前
    beforeUpload(file) {
      const isJPG =
        file.type ==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isJPG1 = file.type == 'application/vnd.ms-excel'
      if (!isJPG && !isJPG1) {
        this.$message.error('上传文件只能是 xls/xlsx 类型!')
      }
      return isJPG || isJPG1
    },
    importStudents() {},
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getCourseRecordList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getCourseRecordList()
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    goLearningOutcome() {
      this.$emit('goLearningOutcomeFromStudent')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
.table_control {
  display: flex;
  justify-content: space-between;
  color: #409eff;
  .table_control_item {
    cursor: pointer;
  }
}
/deep/.el-dialog__body {
  padding-top: 0;
}
.el-row {
  font-size: 14px;
}
/deep/.el-upload {
  width: 100%;
}
.upload__tip {
  margin-left: 16px;
}
.upload__tip:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
</style>